'use client';

import { Containers } from '@/components';
import { Widgets } from '@/components/widgets';

export default function PricingPage() {
    return (
        <>
            <Containers.Section el={<Widgets.Pricing />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
